<template>
  <aw-auchan-shop-area-map-context />
</template>

<script setup lang="ts">
  import AwAuchanShopAreaMapContext from '~~/shop/app/components/Common/Map/AwAuchanShopAreaMapContext.vue';
  import { defineI18nRoute } from '#i18n';

  defineOptions({
    name: 'FoodDeliveryMap',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/food-delivery-map',
      hu: '/kiszallitasi-teruleteink',
    },
  });
</script>
